import React, { FC } from "react";
import { Box, Divider, Typography } from "@mui/material";
import { Container, Dropdown, activeFontStyles } from "./sortByStyles";
import defaultDropdownIcon from "../../assets/drop-down.svg";

type Option = {
  value: string;
  label: string;
};

type StatusFilterProps = {
  selected: string;
  options: Option[];
  setSelected: (value: string) => void;
  variant?: "seller" | "customer";
  isOpen?: boolean;
  onToggle?: (open: boolean) => void;
};

const StatusFilter: FC<StatusFilterProps> = ({
  selected,
  options,
  setSelected,
  variant = "seller",
  isOpen = false,
  onToggle,
}) => {
  const selectedLabel =
    options.find((opt) => opt.value === selected)?.label || "Status";

  const toggle = () => onToggle?.(!isOpen);

  return (
    <Box position="relative" display="flex" flexDirection="column">
      <Container
        variant={variant}
        onClick={toggle}
        sx={{
          width: "auto",
          minWidth: "110px",
          borderRadius: "4px",
        }}
      >
        <Typography sx={activeFontStyles}>{selectedLabel}</Typography>
        <img
          src={defaultDropdownIcon}
          style={{ rotate: isOpen ? "0deg" : "180deg" }}
          alt=""
          width="9.3px"
        />
      </Container>

      {isOpen && (
        <Dropdown
          variant={variant}
          sx={{
            width: "auto",
            minWidth: "110px",
          }}
        >
          {options.map((option, idx) => (
            <React.Fragment key={option.value}>
              <Typography
                sx={activeFontStyles}
                onClick={() => {
                  setSelected(option.value);
                  onToggle?.(false);
                }}
              >
                {option.label}
              </Typography>
              <Divider hidden={idx + 1 === options.length} sx={{ my: "5px" }} />
            </React.Fragment>
          ))}
        </Dropdown>
      )}
    </Box>
  );
};

export default StatusFilter;
